import template from "./home.html";
import controller from "./home.controller";

const homeComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller,
};

export default homeComponent;
